import React from "react";
import "./Works.css";
import Upwork from "../../img/Upwork.png";
import Fiverr from "../../img/fiverr.png";
import Amazon from "../../img/amazon.png";
import Shopify from "../../img/Shopify.png";
import Facebook from "../../img/Facebook.png";
import { motion } from "framer-motion";
import { themeContext } from "../../Context";
import { useContext } from "react";

const Works = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div className="works">
      <div className="awesome">
        <span style={{ color: darkMode ? "white" : "" }}>
          Works fo All these
        </span>
        <span> Brands & Clients</span>
        <span style={{ color: darkMode ? "white" : "" }}>
          {" "}
          Lorem ipsum is simply a dummy text of printing of printing Lorem ipsum{" "}
          <br />
          Lorem ipsum is simply a dummy text of printing Lorem ipsum is simply a
          dummy text of printing of printing Lorem ipsum <br />
          Lorem ipsum is simply a dummy text of printing Lorem ipsum is simply a
          dummy text of printing of printing Lorem ipsum <br />
          Lorem ipsum is simply a dummy text of printing{" "}
        </span>

        <button className="button s-button"> Hire Me</button>

        <div className="blur s-blur" style={{ background: "#abf1ff94" }}></div>
      </div>
      <div className="w-right">
        <motion.div
          initial={{ rotate: 180 }}
          whileInView={{ rotate: 0 }}
          viewport={{ margin: "-40px" }}
          transition={{ duration: 3.5, type: "spring" }}
          className="w-mainCircle"
        >
          <div className="w-secCircle">
            <img src={Upwork} alt="" />
          </div>
          <div className="w-secCircle">
            <img src={Fiverr} alt="" />
          </div>{" "}
          <div className="w-secCircle">
            <img src={Facebook} alt="" />
          </div>{" "}
          <div className="w-secCircle">
            <img src={Shopify} alt="" />
          </div>
          <div className="w-secCircle">
            <img src={Amazon} alt="" />
          </div>
        </motion.div>
        <div className="w-backCircle blueCircle"></div>
        <div className="w-backCircle yellowCircle"></div>
      </div>
    </div>
  );
};

export default Works;
